import { loadView } from '@/router'
import freight from './freight'
import invoice from './invoice'
import legacy from './legacy'
import account from './account'

export default [
  {
    path: 'reports',
    name: 'reports',
    component: loadView('Application/Reports'),
    redirect: {
      name: 'reports-freight'
    },
    children: [
      ...freight,
      ...invoice,
      ...legacy,
      ...account
    ]
  }
]
